export default {"src":"/_next/static/media/connect.eaded578.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};